import { AdFarmApiClient } from "./AdFarmApiClient";
import { AuthResult, DeviceRiskPayload, MobileRole } from "./AdFarmTypes";

export class AuthRepository {
    constructor(private readonly api: AdFarmApiClient) {}

    sendCode(phone: string, risk: DeviceRiskPayload): Promise<unknown> {
        this.validatePhone(phone);
        return this.api.sendCode(phone, risk);
    }

    register(input: { phone: string; code: string; inviteCode: string; role: MobileRole; inviteEntryLockedToUser: boolean; risk: DeviceRiskPayload }): Promise<AuthResult> {
        this.validatePhone(input.phone);
        if (input.code.trim().length < 4) throw new Error("请输入正确的短信验证码");
        if (input.inviteCode.trim().length < 4) throw new Error("必须填写真实邀请码");
        if (input.inviteEntryLockedToUser && input.role !== "user") throw new Error("用户邀请入口只能注册普通用户");
        return this.api.register<AuthResult>(input.role, {
            phone: input.phone,
            code: input.code.trim(),
            inviteCode: input.inviteCode.trim(),
            risk: input.risk,
        });
    }

    login(input: { phone: string; code: string; role: MobileRole; risk: DeviceRiskPayload }): Promise<AuthResult> {
        this.validatePhone(input.phone);
        if (input.code.trim().length < 4) throw new Error("请输入正确的短信验证码");
        return this.api.login<AuthResult>({ phone: input.phone, code: input.code.trim(), role: input.role, risk: input.risk });
    }

    private validatePhone(phone: string): void {
        if (!/^1\d{10}$/.test(phone.trim())) throw new Error("请输入11位中国大陆手机号");
    }
}
